import React from "react";
import PolicyLayout from "./PolicyLayout";

export default function Refund() {
  return (
    <PolicyLayout title="Cancellation & Refund Policy" eyebrow="Legal · Refunds" effectiveDate="Effective Date: March 1, 2023">
      <p>
        This Cancellation &amp; Refund Policy (“Policy”) applies to all services offered through the websites and applications operated by
        <strong> React Disaster Management Solutions OPC Pvt. Ltd.</strong> (the “Company”, “we”, “our”, or “us”), including but not limited to:
      </p>
      <ul>
        <li><a href="https://reactdm.com" target="_blank" rel="noreferrer">reactdm.com</a></li>
        <li><a href="https://reactdms.tech" target="_blank" rel="noreferrer">reactdms.tech</a></li>
        <li><a href="https://wastemanagement.tech" target="_blank" rel="noreferrer">wastemanagement.tech</a></li>
        <li><a href="https://rescigo.com" target="_blank" rel="noreferrer">rescigo.com</a></li>
        <li><a href="https://rescigohealth.com" target="_blank" rel="noreferrer">rescigohealth.com</a></li>
        <li><a href="https://rescigo.in" target="_blank" rel="noreferrer">rescigo.in</a></li>
        <li><a href="https://saferhome.in" target="_blank" rel="noreferrer">saferhome.in</a></li>
        <li><a href="https://bmwtrack.tech" target="_blank" rel="noreferrer">bmwtrack.tech</a></li>
      </ul>
      <p>… and associated mobile applications and portals.</p>

      <h2>1. General Policy</h2>
      <p>
        All payments made for services are considered final once the service is successfully availed.
        No cancellations or refunds will be provided after a service has been delivered or initiated.
        By making a payment on our Platforms, you acknowledge and accept this Policy.
      </p>

      <h2>2. Failed Transactions</h2>
      <p>
        In case of a failed or unsuccessful transaction, any amount deducted from your account will be refunded automatically to the
        original payment method as per RBI and Government guidelines. Refund timelines may vary depending on your bank/payment gateway
        and generally take <strong>5–10 working days</strong>.
      </p>

      <h2>3. Double Payments / Duplicate Charges</h2>
      <p>
        If you are charged more than once for the same service, please notify us with proof of payment. After verification, the excess
        payment will be refunded within <strong>7–10 working days</strong> to the original payment source.
      </p>

      <h2>4. Department-Specific Services</h2>
      <p>
        Certain services delivered in collaboration with Government departments or service providers may have their own refund/cancellation policies.
        In such cases, the respective department/service provider’s policy will override this Policy.
      </p>

      <h2>5. How to Request a Refund</h2>
      <p>If you believe you are eligible for a refund under this Policy, please contact our support team with:</p>
      <ul>
        <li>Transaction ID / Payment Reference</li>
        <li>Date of Payment</li>
        <li>Service availed</li>
        <li>Reason for refund request</li>
      </ul>
      <p>
        📧 <a href="mailto:care@rescigo.in">care@rescigo.in</a><br />
        📞 <a href="tel:+917306087704">7306087704</a>
      </p>
    </PolicyLayout>
  );
}
